import { useAppSelector } from '../reducers';
import { isUngatedForSeatsSelector } from '../selectors/GatingSelectors';
export const useShouldHideDataOrSuitePage = () => {
  const isUngatedForSeats = useAppSelector(isUngatedForSeatsSelector);
  return !isUngatedForSeats;
};